import { createContext, useContext } from 'react'

const AdminLayoutContext = createContext({
  toggleMobileSidebar: () => {},
})

export const useAdminLayout = () => useContext(AdminLayoutContext)

export default AdminLayoutContext
